import {openSelect} from "./_selector-functions";
import {view_initializeMasonry} from "./_view-functions";


export function setup_listeners(selfInstance){
  var $ = jQuery;
  var o = selfInstance.initOptions;

  if (selfInstance.$selectInputForm) {

    selfInstance.$selectInputForm.on('change.dzssel', handle_changeSelectInputForm);
    selfInstance.$selectInputForm.bind('focus', handle_focusSelectInputForm);
    selfInstance.$selectInputForm.bind('focusout', handle_focusSelectInputForm);


      selfInstance.$selectInputForm.get(0).selector_wrap = selfInstance.$wrapperMain;
      if (selfInstance.$selectInputForm.hasClass('do-not-trigger-change-on-init')) {
        selfInstance.$selectInputForm.trigger('change');
      }

  }








  if (String(selfInstance.feedElementClass).indexOf('opener-') > -1) {

    // console.info('_t.parent() - ',_t.parent());


    var $wrapperHead = selfInstance.$dzsSelectorMain.parent().find('.dzs-select-wrapper-head');


    $wrapperHead.data('selector_wrap', selfInstance.$wrapperMain)


    $wrapperHead.on('click', handle_clickWrapperHead)
  } else {

    //console.info(selfInstance.$wrapperMain);
    if (selfInstance.$wrapperMain) {
      selfInstance.$wrapperMain.find('.dzs-select-wrapper-head').bind('click', function () {
        openSelect(selfInstance.$selectInputForm);
      })
    }
  }

  // console.log('o.opener - ', o.opener);
  if (o.opener === ('opener-listbuttons') || o.opener === ('opener-bigoptions') || o.opener === ('opener-radio') || o.opener === ('opener-list')) {

    // console.info("WHERE IS WHERE", _t.parent());
    selfInstance.$wrapperMain.parent().off('click');
    selfInstance.$wrapperMain.parent().on('click', '.select-option', handle_mouse);
  }


    selfInstance.$wrapperMain.on('keyup.dzssel', '.search-field', handle_changeSearchField);

  // -------- functions
  // -------- below


  function handle_mouse(e) {
    var _t = $(this);

    if (e.type === 'click') {
      if (_t.hasClass('select-option')) {

        if (window.dzssel_click_triggered === false) {
          var _t2 = $(this);

          console.log('click .. select-option', _t2, e);

          // -- active

          var isActiveChecked = false;
          var isAnyOptionActive = false;

          if (_t2.hasClass('active-checked')) {
            isActiveChecked = true;
          }


          _t2.removeClass('active-checked');


          // -- if it is select, remove other selected
          _t2.parent().children().removeClass('active-checked');

          if (isActiveChecked === false) {
            _t2.addClass('active-checked');
          }

          // console.info('isActiveChecked - ',isActiveChecked, _t2)

          var ind = _t2.parent().children('.select-option').index(_t2);


          if (selfInstance.$selectInputForm) {

            selfInstance.$selectInputForm.children().eq(ind).prop('selected', true);


            // console.warn("TRIGGER SELECT FROM HERE", 'hmm', _theSelect);
            selfInstance.$selectInputForm.trigger('change');
          }


          var str_curr_selected = '';

          _t2.parent().children().each(function () {
            var _t22 = $(this);

            if (_t22.hasClass('active-checked')) {

              isAnyOptionActive = true;

              if (str_curr_selected) {
                str_curr_selected += ', ';
              }

              str_curr_selected += _t22.find('.the-label--name').text();
            }
          })


          // console.info('sw_is_anyone_active  active-checked - ', sw_is_anyone_active, selfInstance.$wrapperMain.find('.the-text--curr-selected'));
          if (isAnyOptionActive === false) {
            selfInstance.$wrapperMain.find('.the-text--curr-selected').addClass('empty');
          } else {

            selfInstance.$wrapperMain.find('.the-text--curr-selected').removeClass('empty');
            selfInstance.$wrapperMain.find('.the-text--curr-selected').text(str_curr_selected);

          }


          window.dzssel_click_triggered = true;

          setTimeout(function () {
            window.dzssel_click_triggered = false;
          }, 50);


          if(o.opener === ('opener-bigoptions')){

            selfInstance.close_opener({
              'call_from': 'opener click'
            });
          }

          // e.stopPropagation();
          // e.preventDefault();

        }


      }
    }
  }


  /**
   *
   * @param {KeyboardEvent} e
   */
  function handle_changeSearchField(e) {
    var _t = $(this);

    if (e.type === 'keyup') {
      if (_t.hasClass('search-field')) {


        const searchedValue = _t.val();

        if(searchedValue){
          console.log({searchedValue});

        }
        selfInstance.$openerMain.children().each(function () {
          var $option = $(this);
          if (String($option.text()).toLowerCase().indexOf(String(searchedValue).toLowerCase()) > -1) {
            $option.show();
          } else {
            $option.hide();
          }

          if (searchedValue === '') {
            $option.show();
          }
        })
      }
    }
  }


  function handle_clickWrapperHead(e) {
    var _t2 = $(this).data('selector_wrap');


    // console.info(_t2);

    // console.info(e, $(e.target), $(e.target).hasClass('search-field'));


    if ($(e.target).hasClass('search-field')) {


    } else {


      if (_t2.hasClass('active-animation')) {

        if (selfInstance.nativeInputType !== 'checkbox') {

        }
        selfInstance.close_opener({
          'call_from': 'opener click'
        });

      } else {
        selfInstance.open_opener();
      }

    }


    setTimeout(function () {

      view_initializeMasonry(selfInstance);
    }, 500)

  }





  function handle_focusSelectInputForm(e){

    if(e.type==='focusout'){
      selfInstance.$wrapperMain.removeClass('select-focused');
    }
    if(e.type==='focus'){

      if (selfInstance.$wrapperMain.hasClass('skin-beige')) {
        selfInstance.$wrapperMain.addClass('select-focused');
      }
    }
  }


  function handle_changeSelectInputForm(){



    //console.info(_t.parent().find('.dzs-select-wrapper-head .the-text'));
    var val = '';


    val = $(this).find(':selected').html();


    // console.info('selector val for text -',val);

    if (val === '') {
      val = "Select ...";
    }
    // console.info('selector final val for text -',val);

    selfInstance.$dzsSelectorMain.parent().find('.dzs-select-wrapper-head .the-text').html(val);

    var curr_sel_ind = 0;

    for (let i in selfInstance.$selectInputForm.children()) {
      if (selfInstance.$selectInputForm.val() === selfInstance.$selectInputForm.children().eq(i).html()) {
        curr_sel_ind = i;
      }
    }
  }
}